import { useNavigate } from 'react-router-dom';

export default function Page500() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="text-center max-w-sm w-full">

        {/* Icon card */}
        <div className="relative mx-auto w-28 h-28 mb-6">
          <div className="absolute inset-0 bg-red-500/10 rounded-3xl rotate-6" />
          <div className="absolute inset-0 bg-red-500/10 rounded-3xl -rotate-3" />
          <div className="relative w-full h-full bg-gray-800 rounded-3xl flex items-center justify-center border border-gray-700/60">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-red-400">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
        </div>

        {/* Code */}
        <p className="text-[96px] font-black leading-none text-red-500/15 select-none -mb-4">500</p>

        {/* Text */}
        <h1 className="text-2xl font-bold text-white mb-2">Sunucu Hatası</h1>
        <p className="text-gray-400 text-sm leading-relaxed mb-8">
          Sunucuda beklenmedik bir hata oluştu.
          <br />Lütfen daha sonra tekrar deneyin veya sistem yöneticinizle iletişime geçin.
        </p>

        {/* Actions */}
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2.5 rounded-xl bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm font-medium border border-gray-700 transition-colors">
            ← Geri Dön
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-5 py-2.5 rounded-xl bg-red-700 hover:bg-red-600 text-white text-sm font-medium transition-colors">
            Ana Sayfa
          </button>
        </div>
      </div>
    </div>
  );
}
